import React from 'react'
import PropTypes from 'prop-types'
import {Box, Center, Progress} from '@chakra-ui/react'
import {useIntl} from 'react-intl'

const PaginationLegend = ({offset = 0, total = 0, resultsLength = 0}) => {
    const intl = useIntl()
    const current = offset + resultsLength

    // potential divide by 0
    // const progress = total > 0 ? (current / total) * 100 : 0
    const {formatMessage} = useIntl()

    return (
        <Box minW="164px">
            <Center mb={3} textStyle="Semi Bold Small">
                {formatMessage(
                    {
                        id: 'pagination_legend.showing',
                        defaultMessage: '{current} of {total}'
                    },
                    {current, total}
                )}
            </Center>
            <Progress
                value={current}
                size="xs"
                variant="pagination"
                aria-label={intl.formatMessage({
                    defaultMessage: 'Number of products loaded',
                    id: 'plp.load more.assistive_msg.products_loaded'
                })}
                min={offset}
                max={total}
            />
        </Box>
    )
}

PaginationLegend.propTypes = {
    offset: PropTypes.number,
    total: PropTypes.number,
    resultsLength: PropTypes.number
}
export default PaginationLegend
